export default "__VITE_ASSET__TekyklKQ__"